<div class="lg:tw-px-[66px] md:tw-px-[19px] lg:tw-py-[30px] tw-py-0">
    <!-- Dropdown Container -->
    <div class="tw-relative tw-w-full">
        <!-- Dropdown Button -->
        <button
            (click)="toggleDropdown()"
            class="tw-flex tw-items-center tw-justify-between tw-bg-[#024B3F] tw-h-[60px] tw-w-full tw-px-[20px] tw-text-white tw-font-semibold tw-text-[16px] tw-transition-all tw-duration-200 hover:tw-bg-[#035a4a]"
        >
            <span class="tw-text-left tw-flex-1">{{
                getActiveTabTitle()
            }}</span>
            <mat-icon
                class="tw-text-white tw-transition-transform tw-duration-200"
                [ngClass]="{ 'tw-rotate-180': isDropdownOpen }"
            >
                keyboard_arrow_down
            </mat-icon>
        </button>

        <!-- Dropdown Menu -->
        <div
            *ngIf="isDropdownOpen"
            class="tw-absolute tw-top-full tw-left-0 tw-w-full tw-bg-white tw-border tw-border-gray-200 tw-rounded-[12px] tw-shadow-lg tw-z-50 tw-overflow-hidden"
        >
            <button
                *ngFor="let tab of tabs; let last = last"
                (click)="setActive(tab.slug)"
                [attr.ga-event-id]="tab.slug + '_button_jc3_click'"
                [attr.ga-event-category]="'JC3 Button'"
                [attr.ga-event-label]="tab?.title + ' Button Click'"
                ga-track="track"
                class="tw-w-full tw-text-left tw-px-[20px] tw-h-[60px] tw-flex tw-flex-auto tw-items-center tw-text-[14px] tw-font-medium tw-transition-colors tw-duration-150 hover:tw-bg-gray-50 tw-border-b tw-border-[#7B7575]"
                [ngClass]="{
                    'tw-bg-white tw-text-[#024B3F] !tw-font-bold !tw-hidden':
                        activeTab === tab.slug,
                    'tw-bg-white tw-text-[#024B3F] !tw-font-bold tw-border-b-0':
                        activeTab === tab.slug && last,
                    'tw-bg-white tw-text-black hover:tw-text-[#024B3F] hover:!tw-font-bold':
                        activeTab !== tab.slug && !last,
                    'tw-bg-white tw-text-black tw-border-b-0':
                        activeTab !== tab.slug && last
                }"
            >
                {{ tab.title }}
                <!-- <mat-icon
                    class="tw-transition-transform tw-duration-200"
                    [ngClass]="{
                        'tw-text-[#024B3F]': activeTab === tab.slug,
                        'tw-text-black': activeTab !== tab.slug
                    }"
                >
                    keyboard_arrow_down
                </mat-icon> -->
            </button>
        </div>
    </div>

    <!-- Tab Body -->
    <div class="custom-tab-body">
        <bg-container *ngIf="activeTab === tabs[0].slug">
            <app-introduction></app-introduction>
        </bg-container>
        <bg-container *ngIf="activeTab === tabs[1].slug">
            <app-jumpstart-guide></app-jumpstart-guide>
        </bg-container>
        <bg-container *ngIf="activeTab === tabs[2].slug">
            <app-capacity-building></app-capacity-building>
        </bg-container>
        <bg-container *ngIf="activeTab === tabs[3].slug">
            <app-certification></app-certification>
        </bg-container>
        <bg-container *ngIf="activeTab === tabs[4].slug">
            <app-financing-solutions></app-financing-solutions>
        </bg-container>
    </div>
</div>
